import { FC } from 'react';

import { useEventContext } from '../../hooks/contexts/event.context';
import { parseEventTerms } from '../../hooks/contexts/helpers/eventTerms';
import { useI18nContext } from '../../hooks/contexts/i18n.context';
import { useModalContext } from '../../hooks/contexts/modal.context';
import * as Styles from './term-modal.styles';

const TermModal: FC = () => {
  const { translate } = useI18nContext();
  const { toggleModal } = useModalContext();

  const { event } = useEventContext();

  const { title, description } = parseEventTerms(event?.attributes?.terms?.value);

  return (
    <Styles.Body>
      <Styles.Text>
        {title.trim()}
      </Styles.Text>
      <Styles.TextInfo dangerouslySetInnerHTML={{ __html : description }}>
      </Styles.TextInfo>
      <Styles.BtnContainer>
        <Styles.CutomBtn onClick={() => toggleModal({ open : false })}>
          {translate(['INFORMATION', 'UNDERSTOOD'])}
        </Styles.CutomBtn>
      </Styles.BtnContainer>
    </Styles.Body>
  );
};

export default TermModal;
